import { Head, Link } from "@inertiajs/react";
import { ArrowLeft, ChevronRight, ListTodo, NotebookPen, Sparkles } from "lucide-react";

import { Button } from "@/components/ui/button";
import {
  Item,
  ItemActions,
  ItemContent,
  ItemDescription,
  ItemTitle,
} from "@/components/ui/item";
import AppLayout from "@/layouts/app-layout";
import {
  purchaseRequestsPath,
  quickNewPurchaseRequestsPath,
  simpleNewPurchaseRequestsPath,
  uploadNewPurchaseRequestsPath,
} from "@/routes";
import type { BreadcrumbItem } from "@/types";

const breadcrumbs: BreadcrumbItem[] = [
  {
    title: "Solicitudes Compras",
    href: purchaseRequestsPath(),
  },
  {
    title: "Nueva Solicitud",
    href: "#",
  },
];

export default function NewPurchaseRequest() {
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Nueva Solicitud de Compra" />

      <div className="flex h-full flex-1 flex-col gap-6 p-6">
        {/* Header */}
        <div>
          <Button variant="ghost" size="sm" asChild className="mb-3">
            <Link href={purchaseRequestsPath()}>
              <ArrowLeft className="h-4 w-4 mr-2" />
              Volver a Solicitudes
            </Link>
          </Button>
        </div>

       {/* Info adicional */}
        <div className="mx-auto w-full max-w-2xl mt-4">
          <div className="rounded-lg border bg-muted/50 p-4 text-sm text-muted-foreground">
            <p>
              <strong className="text-foreground">Nota:</strong> Todas las solicitudes pueden
              ser editadas después de su creación. Elige el método que mejor se adapte a tu
              situación actual.
            </p>
          </div>
        </div>

        {/* Options */}
        <div className="mx-auto w-full max-w-2xl flex flex-col gap-4">
          {/* Opción Simple */}
          <Item variant={"outline"} asChild>
            <Link href={simpleNewPurchaseRequestsPath()}>
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-blue-100 text-blue-600 shrink-0">
                <ListTodo className="h-6 w-6" />
              </div>
              <ItemContent>
                <ItemTitle>Creación Simple</ItemTitle>
                <ItemDescription>
                  Forma rápida y directa. Ideal para mobile. Selecciona productos del catálogo,
                  especifica cantidades y envía. Sin procesamiento de IA.
                </ItemDescription>
              </ItemContent>
              <ItemActions>
                <ChevronRight className="h-5 w-5 text-muted-foreground" />
              </ItemActions>
            </Link>
          </Item>

          {/* Opción por Texto */}
          <Item variant={"outline"} asChild>
            <Link href={quickNewPurchaseRequestsPath()}>
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-purple-100 text-purple-600 shrink-0">
                <NotebookPen className="h-6 w-6" />
              </div>
              <ItemContent>
                <ItemTitle>Creación por Texto IA</ItemTitle>
                <ItemDescription>
                  Escribe tu pedido o copia y pega el texto y la IA extraerá automáticamente
                  los productos, cantidades y unidades. Puedes revisar y ajustar antes de crear.
                </ItemDescription>
              </ItemContent>
              <ItemActions>
                <ChevronRight className="h-5 w-5 text-muted-foreground" />
              </ItemActions>
            </Link>
          </Item>

          {/* Opción desde Documento */}
          <Item variant={"outline"} asChild>
            <Link href={uploadNewPurchaseRequestsPath()}>
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-emerald-100 text-emerald-600 shrink-0">
                <Sparkles className="h-6 w-6" />
              </div>
              <ItemContent>
                <ItemTitle>Escaneo con IA</ItemTitle>
                <ItemDescription>
                  Sube un PDF o imagen de tu solicitud y la IA procesará el documento
                  extrayendo automáticamente todos los ítems con sus detalles.
                </ItemDescription>
              </ItemContent>
              <ItemActions>
                <ChevronRight className="h-5 w-5 text-muted-foreground" />
              </ItemActions>
            </Link>
          </Item>
        </div>

 
      </div>
    </AppLayout>
  );
}
